import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-down-light",
  "use": "icon-arrow-down-light-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-arrow-down-light\">\n<path d=\"M9.375 12.6063L7.13125 10.3688L6.25 11.25L10 15L13.75 11.25L12.8688 10.3688L10.625 12.6063V5H9.375V12.6063Z\" fill=\"#ccd3dd\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol